import { Box, Image, Stack, Text, Title } from '@mantine/core';
import { type FC } from 'react';
import LightdashLogo from '../../svgs/lightdash-black.svg';
import MantineLinkButton from '../common/MantineLinkButton';
// DL Fork: accepts an optional projectUuid so the "Back to home page" link
// can land on project home inside the host-app iframe (the org root is
// unreachable for non-admin operators). MobileGuard passes it through.
import classes from './Mobile.module.css';

type Props = {
    projectUuid?: string;
};

const MobileView: FC<Props> = ({ projectUuid }) => {
    const homeHref = projectUuid ? `/projects/${projectUuid}/home` : '/';

    return (
        <Box w="100vw" h="100vh" className={classes.mobileView}>
            <Stack align="center" gap="xl" justify="start" p="5xl">
                <Image
                    src={LightdashLogo}
                    alt="lightdash logo"
                    maw="8xl"
                    my="lg"
                />
                <Box component="span" className={classes.emoji}>
                    &#128586;
                </Box>
                <Title ta="center" order={4}>
                    This page is not available to view on mobile yet.
                </Title>
                <Text ta="center" c="ldGray.6">
                    Sign in on a laptop or desktop to access this page!
                </Text>
                <MantineLinkButton href={homeHref}>
                    Back to home page
                </MantineLinkButton>
            </Stack>
        </Box>
    );
};

export default MobileView;
